import React , {useContext} from 'react'
import { MouseContext } from "../../context/mouseContext"

import Menu from './Menu';

import './menu.css'


const handleClick = () =>{
    document.querySelector('.menu-overlay').classList.toggle('active');
    document.querySelector('.menu').classList.toggle('active');
  
    document.querySelector('.all').classList.toggle('active');
}

const Aside = () => {
    const {  cursorChangeHandler } = useContext(MouseContext);

    return (
        <div 
        className="all"
        >
            <div className="menu-overlay" id="menu-overlay"></div>
            <div 
                className="aside-menu" 
                onMouseEnter={() => cursorChangeHandler("hovered")}
                onMouseLeave={() => cursorChangeHandler("")}
                onClick ={handleClick}
            >
                <span className="line"></span>
                <span className="line"></span>
                <span className="line"></span>
                <span className="text">Menu</span>
            </div>
            <Menu/>
        </div>
    
    )
}

export default Aside;
